module.exports = __webpack_public_path__ + "static/media/Artboard16.d52be788.png";